import React from "react";
import {
  Button,
  Col,
  Collapse,
  CollapseProps,
  Grid,
  List,
  Row,
  Typography,
  theme,
} from "antd";
import { Content } from "antd/es/layout/layout";
import {
  StyledDemoButton,
  StyledImage,
  StyledImageDiv,
  StyledImageDiv2,
  StyledHeroTitle,
  StyledGradientText,
  StyledRedGradientText,
  StyledHeroSubtitle,
} from "./styles";
import {
  CaretRightOutlined,
  LinkedinFilled,
  LinkOutlined,
  FileTextOutlined,
  EditOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";
import { CSSProperties, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import VideoModal from "./components/VideoModal";
import Footer from "./components/Footer";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

export const LandingPage = () => {
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const screens = useBreakpoint();

  const panelStyle: React.CSSProperties = {
    marginBottom: 10,
    fontSize: "16px",
    fontWeight: "500",
    borderBottom: "1px solid black",
    fontFamily: "Inter",
  };

  const getItems: (panelStyle: CSSProperties) => CollapseProps["items"] = (
    panelStyle,
  ) => [
    {
      key: "1",
      label: "What is Media Nest?",
      children: (
        <p>
          Media Nest is an AI powered tool that can self generate news, stories
          and even articles from source material which is provided by the user.
        </p>
      ),
      style: panelStyle,
    },
    {
      key: "2",
      label: "How does Media Nest work?",
      children: (
        <p>
          Media Nest operates as an automated content creation and distribution
          network, leveraging advanced language models to transform raw news
          data into engaging and informative multimedia content for diverse
          audiences.
        </p>
      ),
      style: panelStyle,
    },
    {
      key: "3",
      label: "Which businesses can benefit from Media Nest?",
      children: (
        <p>
          Any business or organization that relies on content creation, analysis
          of news data, or communication with stakeholders can benefit from
          integrating Media Nest into their workflows to streamline processes,
          enhance productivity, and deliver more impactful content and
          messaging.
        </p>
      ),
      style: panelStyle,
    },

    {
      key: "4",
      label: "Can Media Nest integrate with other business systems?",
      children: (
        <p>
          By fostering integration with other businesses and systems, Media Nest
          can create a more seamless and versatile experience for its users,
          enabling them to leverage its content generation capabilities within
          their existing workflows and processes.
        </p>
      ),
      style: panelStyle,
    },
  ];

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight * 0.1) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToElement = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  const [isVideoModalVisible, setVideoModalVisible] = useState(false);

  const handleOpenVideoModal = () => {
    setVideoModalVisible(true);
    document.body.style.overflow = "hidden";
  };

  const handleCloseVideoModal = () => {
    setVideoModalVisible(false);
    document.body.style.overflow = "auto";
  };

  return (
    <Content style={{ background: "white" }}>
      <Content
        style={{ height: "100%", overflowY: "auto", overflowX: "hidden" }}
      >
        <div
          style={{
            background:
              "linear-gradient(90deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.3) 30%, rgba(222, 40, 59, 0.1) 100%)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            backgroundPosition: "left top",
          }}
        >
          <Row justify={"center"} align={"middle"}>
            <Col
              id="Hero"
              xs={24}
              sm={24}
              md={{ span: 16 }}
              lg={{ span: 14 }}
              xl={{ span: 12 }}
              style={{
                textAlign: screens.xs ? "center" : "left",
                height: "98vh",
                position: "relative",
                overflow: "hidden",
                marginTop: "-40px",
              }}
            >
              <div
                style={{
                  position: "relative",
                  height: "100%",
                  zIndex: "1",
                  backgroundColor: "transparent",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  // alignItems: "center",
                }}
              >
                <Row
                  align={"middle"}
                  justify={
                    screens.xl || screens.xxl
                      ? "center"
                      : screens.xs
                        ? "center"
                        : "center"
                  }
                >
                  <Col
                    xs={22}
                    md={20}
                    lg={24}
                    style={{
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: "0.75rem",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#B8000080",
                          border: "0.5px solid white",
                          borderRadius: "20px",
                          padding: "8px 16px",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <ThunderboltOutlined
                          style={{
                            fontSize: "12px",
                            color: "white",
                          }}
                        />
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 500,
                            color: "white",
                            fontFamily: "Manrope",
                          }}
                        >
                          AI-Powered News Platform
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        width:
                          screens.xxl || screens.xl
                            ? "70%"
                            : screens.lg
                              ? "75%"
                              : screens.md
                                ? "80%"
                                : screens.sm
                                  ? "90%"
                                  : "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <StyledHeroTitle level={1} $textAlign="center">
                        <StyledGradientText>
                          Mera Peshawar —{" "}
                        </StyledGradientText>
                        <StyledRedGradientText>
                          Meri Khabar
                        </StyledRedGradientText>
                      </StyledHeroTitle>

                      <StyledHeroSubtitle level={4}>
                        From street-level stories to major developments, we
                        cover Peshawar and Khyber Pakhtunkhwa with clarity,
                        responsibility, and truth.
                      </StyledHeroSubtitle>
                    </div>
                  </Col>
                </Row>

                <Row
                  justify={"center"}
                  align={"middle"}
                  gutter={screens.xs ? [8, 8] : [0, 0]}
                  style={{ width: "100%" }}
                >
                  <Col
                    xs={screens.xs ? 24 : undefined}
                    style={{
                      display: "flex",
                      justifyContent: screens.xs ? "center" : "flex-start",
                    }}
                  >
                    <StyledDemoButton
                      style={{
                        justifyContent: "center",
                        marginTop: "20px",
                        width: screens.xs
                          ? "80%"
                          : screens.xl || screens.xxl
                            ? "200px"
                            : screens.lg
                              ? "160px"
                              : "130px",
                      }}
                      type="primary"
                      onClick={() => navigate("/NewsList")}
                    >
                      Try Now
                    </StyledDemoButton>
                  </Col>
                  <Col
                    xs={screens.xs ? 24 : undefined}
                    style={{
                      display: "flex",
                      justifyContent: screens.xs ? "center" : "flex-start",
                    }}
                  >
                    {/* <StyledDemoButton
                      style={{
                        justifyContent: "center",
                        marginTop: screens.xs ? "10px" : "20px",
                        marginLeft: screens.xs ? "0" : "10px",
                        background: "transparent",
                        width: screens.xs
                          ? "80%"
                          : screens.xl || screens.xxl
                            ? "200px"
                            : screens.lg
                              ? "160px"
                              : "130px",
                      }}
                      type="primary"
                      onClick={() => {
                        handleOpenVideoModal();
                        scrollToElement("Main");
                      }}
                    >
                      Watch Demo
                    </StyledDemoButton> */}
                  </Col>

                  <VideoModal
                    isVisible={isVideoModalVisible}
                    onClose={handleCloseVideoModal}
                    videoSrc="Demo.mp4"
                  />
                </Row>

                <Row
                  justify={"center"}
                  align={"middle"}
                  style={{ width: "100%", marginTop: "30px" }}
                >
                  <Col
                    xs={24}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <img
                      src="powered-by-media-nest.png"
                      alt="Powered by Media Nest"
                      style={{
                        maxWidth: "250px",
                        width: "100%",
                        height: "auto",
                      }}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>

        <Row justify="center" id="featureRow">
          <Col xs={24} md={24} lg={24} style={{ textAlign: "center" }}>
            <Title
              style={{
                fontSize: screens.xxl
                  ? "50px"
                  : screens.xl
                    ? "42px"
                    : screens.lg
                      ? "34px"
                      : screens.md
                        ? "26px"
                        : screens.sm
                          ? "20px"
                          : screens.xs
                            ? "18px"
                            : "clamp(20px, 5vw, 50px)",
                color: "#DE283B",
                fontWeight: "700",
                fontFamily: "Inter",
              }}
            >
              Personalized AI News
            </Title>
            <Col lg={{ span: 24 }}>
              <Title
                level={4}
                style={{
                  fontWeight: 400,
                  fontFamily: "Inter",
                  color: "black",
                  fontSize: screens.xxl
                    ? "20px"
                    : screens.xl
                      ? "18px"
                      : screens.lg
                        ? "16px"
                        : screens.md
                          ? "14px"
                          : screens.sm
                            ? "13px"
                            : screens.xs
                              ? "12px"
                              : "15px",
                  textAlign: "center",
                }}
              >
                Our platform leverages AI tools to revolutionalize content
                creation, offering a suite of features<br></br> for generating
                customized news and articles that meet diverse<br></br> media
                and communication demands.
              </Title>
            </Col>
          </Col>
        </Row>

        <Row justify="center">
          <Col
            style={{
              marginTop: screens.xs ? "20px" : "50px",
              marginBottom: screens.xs ? "20px" : "0",
              padding: screens.xs ? "15px" : screens.sm ? "25px" : "40px",
              maxWidth: "1200px",
              width: "100%",
            }}
            xs={24}
            lg={24}
          >
            <Row justify={"center"} align={"middle"} gutter={[16, 24]}>
              <Col
                xs={{ span: 24, order: 2 }}
                sm={{ span: 24, order: 2 }}
                md={{ span: 12, order: 1 }}
                lg={{ span: 12, order: 1 }}
              >
                <Col xs={24}>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                      maxWidth: "600px",
                      borderRadius: "16px",
                      overflow: "hidden",
                      boxShadow:
                        "0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      if (!screens.xs) {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow =
                          "0 25px 70px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.05)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!screens.xs) {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)";
                      }
                    }}
                  >
                    <img
                      src="NewsGen.png"
                      alt="hero"
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                        borderRadius: "16px",
                      }}
                    />
                  </div>
                </Col>
              </Col>

              <Col
                xs={{ span: 24, order: 1 }}
                sm={{ span: 24, order: 1 }}
                md={{ span: 12, order: 2 }}
                lg={{ span: 12, order: 2 }}
              >
                <Col
                  xs={24}
                  style={{
                    marginTop: screens.xs ? "10px" : "20px",
                    textAlign: screens.xs ? "center" : "left",
                    padding: screens.xs ? "10px" : screens.sm ? "20px" : "30px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: screens.xs ? "center" : "flex-start",
                      gap: screens.xs ? "8px" : "12px",
                      marginBottom: screens.xs ? "15px" : "20px",
                    }}
                  >
                    <div
                      style={{
                        width: screens.xs ? "50px" : "60px",
                        height: screens.xs ? "50px" : "60px",
                        borderRadius: "12px",
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                      }}
                    >
                      <FileTextOutlined
                        style={{
                          fontSize: screens.xxl
                            ? "24px"
                            : screens.xl
                              ? "22px"
                              : screens.lg
                                ? "20px"
                                : screens.md
                                  ? "18px"
                                  : screens.sm
                                    ? "18px"
                                    : screens.xs
                                      ? "18px"
                                      : "20px",
                          color: "white",
                        }}
                      />
                    </div>
                  </div>

                  <Title
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: screens.xxl
                        ? "34px"
                        : screens.xl
                          ? "28px"
                          : screens.lg
                            ? "22px"
                            : screens.md
                              ? "18px"
                              : screens.sm
                                ? "16px"
                                : screens.xs
                                  ? "14px"
                                  : "22px",
                      marginBottom: "16px",
                      color: "#1a1a1a",
                    }}
                  >
                    News Generation
                  </Title>
                  <Text
                    style={{
                      fontSize: screens.xxl
                        ? "18px"
                        : screens.xl
                          ? "16px"
                          : screens.lg
                            ? "14px"
                            : screens.md
                              ? "13px"
                              : screens.sm
                                ? "12px"
                                : screens.xs
                                  ? "11px"
                                  : "14px",
                      fontWeight: 400,
                      lineHeight: "1.8",
                      color: "#666",
                      display: "block",
                    }}
                  >
                    This tool leverages advanced Large Language Models (LLM) to
                    generate news content across various topics and genres,
                    streamlining content creation with AI.​
                  </Text>
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row justify="center">
          <Col
            style={{
              background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
              marginTop: screens.xs ? "20px" : "50px",
              borderBottomRightRadius: screens.xs ? "30px" : "100px",
              borderTopLeftRadius: screens.xs ? "30px" : "100px",
              boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
              padding: screens.xs ? "15px" : screens.sm ? "25px" : "40px",
              maxWidth: "1200px",
              width: "100%",
            }}
            xs={24}
            lg={24}
          >
            <Row justify={"center"} align={"middle"} gutter={[16, 24]}>
              <Col xs={24} sm={24} md={12} lg={{ span: 10, offset: 1 }}>
                <Col
                  xs={24}
                  style={{
                    textAlign: screens.xs ? "center" : "left",
                    padding: screens.xs ? "10px" : screens.sm ? "20px" : "30px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: screens.xs ? "center" : "flex-start",
                      gap: screens.xs ? "8px" : "12px",
                      marginBottom: screens.xs ? "15px" : "20px",
                    }}
                  >
                    <div
                      style={{
                        width: screens.xs ? "50px" : "60px",
                        height: screens.xs ? "50px" : "60px",
                        borderRadius: "12px",
                        background:
                          "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 4px 15px rgba(245, 87, 108, 0.4)",
                      }}
                    >
                      <EditOutlined
                        style={{
                          fontSize: screens.xxl
                            ? "24px"
                            : screens.xl
                              ? "22px"
                              : screens.lg
                                ? "20px"
                                : screens.md
                                  ? "18px"
                                  : screens.sm
                                    ? "18px"
                                    : screens.xs
                                      ? "18px"
                                      : "20px",
                          color: "white",
                        }}
                      />
                    </div>
                  </div>
                  <Title
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: screens.xxl
                        ? "34px"
                        : screens.xl
                          ? "28px"
                          : screens.lg
                            ? "22px"
                            : screens.md
                              ? "18px"
                              : screens.sm
                                ? "16px"
                                : screens.xs
                                  ? "14px"
                                  : "22px",
                      marginBottom: "16px",
                      color: "#1a1a1a",
                    }}
                  >
                    Article Generation
                  </Title>
                  <Text
                    style={{
                      fontSize: screens.xxl
                        ? "18px"
                        : screens.xl
                          ? "16px"
                          : screens.lg
                            ? "14px"
                            : screens.md
                              ? "13px"
                              : screens.sm
                                ? "12px"
                                : screens.xs
                                  ? "11px"
                                  : "14px",
                      fontWeight: 400,
                      lineHeight: "1.8",
                      color: "#666",
                      display: "block",
                    }}
                  >
                    The textual content is processed using LLM to convert the
                    raw feed into well-structured articles. The LLM organizes
                    the content with proper headings, ensuring that the articles
                    are readable and formatted for better comprehension.
                  </Text>
                </Col>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={12}
                style={{
                  order: screens.xs || screens.sm ? 2 : 2,
                }}
              >
                <Col xs={24}>
                  <div
                    style={{
                      marginTop: screens.xs ? "10px" : "0px",
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                      maxWidth: "600px",
                      borderRadius: "16px",
                      overflow: "hidden",
                      boxShadow:
                        "0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      if (!screens.xs) {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow =
                          "0 25px 70px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.05)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!screens.xs) {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)";
                      }
                    }}
                  >
                    <img
                      src="articlegen.png"
                      alt="hero"
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                        borderRadius: "16px",
                      }}
                    />
                  </div>
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row justify="center">
          <Col
            style={{
              marginTop: screens.xs ? "20px" : "50px",
              marginBottom: screens.xs ? "20px" : "50px",
              padding: screens.xs ? "15px" : screens.sm ? "25px" : "40px",
              maxWidth: "1200px",
              width: "100%",
            }}
            xs={24}
            lg={24}
          >
            <Row justify={"center"} align={"middle"} gutter={[16, 24]}>
              <Col
                xs={{ span: 24, order: 2 }}
                sm={{ span: 24, order: 2 }}
                md={{ span: 12, order: 1 }}
                lg={{ span: 12, order: 1 }}
              >
                <Col xs={24}>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                      maxWidth: "600px",
                      borderRadius: "16px",
                      overflow: "hidden",
                      boxShadow:
                        "0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      if (!screens.xs) {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow =
                          "0 25px 70px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.05)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!screens.xs) {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)";
                      }
                    }}
                  >
                    <img
                      src="Vidgen.png"
                      alt="hero"
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                        borderRadius: "16px",
                      }}
                    />
                  </div>
                </Col>
              </Col>
              <Col
                xs={{ span: 24, order: 1 }}
                sm={{ span: 24, order: 1 }}
                md={{ span: 12, order: 2 }}
                lg={{ span: 12, order: 2 }}
              >
                <Col
                  xs={24}
                  style={{
                    marginTop: screens.xs ? "10px" : "20px",
                    textAlign: screens.xs ? "center" : "left",
                    padding: screens.xs ? "10px" : screens.sm ? "20px" : "30px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: screens.xs ? "center" : "flex-start",
                      gap: screens.xs ? "8px" : "12px",
                      marginBottom: screens.xs ? "15px" : "20px",
                    }}
                  >
                    <div
                      style={{
                        width: screens.xs ? "50px" : "60px",
                        height: screens.xs ? "50px" : "60px",
                        borderRadius: "12px",
                        background:
                          "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 4px 15px rgba(79, 172, 254, 0.4)",
                      }}
                    >
                      <VideoCameraOutlined
                        style={{
                          fontSize: screens.xxl
                            ? "24px"
                            : screens.xl
                              ? "22px"
                              : screens.lg
                                ? "20px"
                                : screens.md
                                  ? "18px"
                                  : screens.sm
                                    ? "18px"
                                    : screens.xs
                                      ? "18px"
                                      : "20px",
                          color: "white",
                        }}
                      />
                    </div>
                  </div>

                  <Title
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: screens.xxl
                        ? "34px"
                        : screens.xl
                          ? "28px"
                          : screens.lg
                            ? "22px"
                            : screens.md
                              ? "18px"
                              : screens.sm
                                ? "16px"
                                : screens.xs
                                  ? "14px"
                                  : "22px",
                      marginBottom: "16px",
                      color: "#1a1a1a",
                    }}
                  >
                    Media Generation
                  </Title>
                  <Text
                    style={{
                      fontSize: screens.xxl
                        ? "18px"
                        : screens.xl
                          ? "16px"
                          : screens.lg
                            ? "14px"
                            : screens.md
                              ? "13px"
                              : screens.sm
                                ? "12px"
                                : screens.xs
                                  ? "11px"
                                  : "14px",
                      fontWeight: 400,
                      lineHeight: "1.8",
                      color: "#666",
                      display: "block",
                    }}
                  >
                    It utilizes AI models to convert text into lifelike audio or
                    video, offering users the ability to choose the avatar and
                    speaker's voice for a more personalized and engaging
                    experience.​
                  </Text>
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row justify="center">
          <Col
            style={{
              background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
              marginTop: screens.xs ? "20px" : "50px",
              borderBottomRightRadius: screens.xs ? "30px" : "100px",
              borderTopLeftRadius: screens.xs ? "30px" : "100px",
              boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
              padding: screens.xs ? "15px" : screens.sm ? "25px" : "40px",
              maxWidth: "1200px",
              width: "100%",
            }}
            xs={24}
            lg={24}
          >
            <Row justify={"center"} align={"middle"} gutter={[16, 24]}>
              <Col
                xs={{ span: 24, order: 1 }}
                sm={{ span: 24, order: 1 }}
                md={{ span: 12, order: 1 }}
                lg={{ span: 10, offset: 1, order: 1 }}
              >
                <Col
                  xs={24}
                  style={{
                    textAlign: screens.xs ? "center" : "left",
                    padding: screens.xs ? "10px" : screens.sm ? "20px" : "30px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: screens.xs ? "center" : "flex-start",
                      gap: screens.xs ? "8px" : "12px",
                      marginBottom: screens.xs ? "15px" : "20px",
                    }}
                  >
                    <div
                      style={{
                        width: screens.xs ? "50px" : "60px",
                        height: screens.xs ? "50px" : "60px",
                        borderRadius: "12px",
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 4px 15px rgba(102, 126, 234, 0.5)",
                      }}
                    >
                      <UploadOutlined
                        style={{
                          fontSize: screens.xxl
                            ? "24px"
                            : screens.xl
                              ? "22px"
                              : screens.lg
                                ? "20px"
                                : screens.md
                                  ? "18px"
                                  : screens.sm
                                    ? "18px"
                                    : screens.xs
                                      ? "18px"
                                      : "20px",
                          color: "white",
                        }}
                      />
                    </div>
                  </div>
                  <Title
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: screens.xxl
                        ? "34px"
                        : screens.xl
                          ? "28px"
                          : screens.lg
                            ? "22px"
                            : screens.md
                              ? "18px"
                              : screens.sm
                                ? "16px"
                                : screens.xs
                                  ? "14px"
                                  : "22px",
                      marginBottom: "16px",
                      color: "#1a1a1a",
                    }}
                  >
                    Social Media Upload
                  </Title>
                  <Text
                    style={{
                      fontSize: screens.xxl
                        ? "18px"
                        : screens.xl
                          ? "16px"
                          : screens.lg
                            ? "14px"
                            : screens.md
                              ? "13px"
                              : screens.sm
                                ? "12px"
                                : screens.xs
                                  ? "11px"
                                  : "14px",
                      fontWeight: 400,
                      lineHeight: "1.8",
                      color: "#666",
                      display: "block",
                    }}
                  >
                    Seamlessly upload your generated videos to popular social
                    media platforms. Our platform streamlines the distribution
                    process, allowing you to share your AI-generated content
                    across multiple channels with just a few clicks.
                  </Text>
                </Col>
              </Col>
              <Col
                xs={{ span: 24, order: 2 }}
                sm={{ span: 24, order: 2 }}
                md={{ span: 12, order: 2 }}
                lg={{ span: 12, order: 2 }}
              >
                <Col xs={24}>
                  <div
                    style={{
                      marginTop: screens.xs ? "10px" : "0px",
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                      maxWidth: "600px",
                      borderRadius: "16px",
                      overflow: "hidden",
                      boxShadow:
                        "0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      if (!screens.xs) {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow =
                          "0 25px 70px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.05)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!screens.xs) {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)";
                      }
                    }}
                  >
                    <img
                      src="step4.jpg"
                      alt="social media upload"
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                        borderRadius: "16px",
                      }}
                    />
                  </div>
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* FAQ Section */}
        <Row
          justify="center"
          id="FAQS"
          style={{
            marginTop: screens.xs ? "40px" : "80px",
            marginBottom: screens.xs ? "30px" : "50px",
            background:
              "linear-gradient(90deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.85) 30%, rgba(222, 40, 59, 0.02) 100%)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            width: "100%",
            padding: screens.xs ? "30px 0" : "60px 0",
          }}
        >
          <Col xs={22} md={20} lg={{ span: 12 }}>
            <Title
              style={{
                marginBottom: "50px",
                textAlign: "center",
                fontFamily: "Inter",
                fontSize: screens.xxl
                  ? "36px"
                  : screens.xl
                    ? "32px"
                    : screens.lg
                      ? "28px"
                      : screens.md
                        ? "24px"
                        : screens.sm
                          ? "20px"
                          : screens.xs
                            ? "18px"
                            : "32px",
              }}
              level={1}
            >
              Frequently Asked Questions.
            </Title>
            <Content style={{ textAlign: "start", width: "100%" }}>
              <Collapse
                size="large"
                bordered={false}
                expandIcon={({ isActive }) => (
                  <CaretRightOutlined rotate={isActive ? 90 : 0} />
                )}
                style={{ background: "transparent" }}
                accordion
                items={getItems(panelStyle)}
              />
            </Content>
          </Col>
        </Row>
      </Content>
      <Footer />
    </Content>
  );
};

export default LandingPage;
